export default __webpack_public_path__ + "static/media/map.ae4fa3a6.svg";